(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    (() => {
    const pickerSelector = '[data-ds-variant-picker]';

    if (window.DomovStromovVariantPicker?.initializeAll) {
      window.DomovStromovVariantPicker.initializeAll();
      return;
    }

    const setPanelExpanded = (unavailablePanel, toggle, actionText, fieldset, expanded) => {
      unavailablePanel.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      actionText.textContent = expanded ? fieldset.dataset.hideLabel : fieldset.dataset.showLabel;
    };

    const initializePicker = (fieldset) => {
      if (fieldset.dataset.dsVariantInitialized === 'true') return;

      const inputs = Array.from(fieldset.children).filter((child) => child.matches('input.input-radio'));
      if (!inputs.length) return;

      fieldset.dataset.dsVariantInitialized = 'true';

      const availableOptions = document.createElement('div');
      availableOptions.className = 'ds-variant-picker__available';

      const unavailablePanel = document.createElement('section');
      unavailablePanel.className = 'ds-variant-picker__unavailable';

      const toggle = document.createElement('button');
      toggle.className = 'ds-variant-picker__toggle';
      toggle.type = 'button';
      toggle.setAttribute('aria-expanded', 'false');

      const title = document.createElement('span');
      title.className = 'ds-variant-picker__toggle-title';

      const action = document.createElement('span');
      action.className = 'ds-variant-picker__toggle-action';

      const actionText = document.createElement('span');
      actionText.textContent = fieldset.dataset.showLabel;

      const chevron = document.createElement('span');
      chevron.className = 'ds-variant-picker__chevron';
      chevron.setAttribute('aria-hidden', 'true');

      action.append(actionText, chevron);
      toggle.append(title, action);

      const viewport = document.createElement('div');
      viewport.className = 'ds-variant-picker__unavailable-viewport';

      const unavailableOptions = document.createElement('div');
      unavailableOptions.className = 'ds-variant-picker__unavailable-options';
      unavailableOptions.id = `${fieldset.id}-unavailable`;
      toggle.setAttribute('aria-controls', unavailableOptions.id);

      viewport.append(unavailableOptions);
      unavailablePanel.append(toggle, viewport);
      fieldset.append(availableOptions, unavailablePanel);

      const optionItems = inputs.map((input) => ({
        input,
        label: fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`),
      })).filter((item) => item.label);

      const setExpanded = (expanded) => {
        setPanelExpanded(unavailablePanel, toggle, actionText, fieldset, expanded);
      };

      const syncOptions = () => {
        let unavailableCount = 0;
        let selectedUnavailable = false;

        optionItems.forEach(({ input, label }) => {
          const unavailable = input.classList.contains('disabled');
          const destination = unavailable ? unavailableOptions : availableOptions;

          input.setAttribute('aria-disabled', String(unavailable));
          label.classList.toggle('ds-variant-option--unavailable', unavailable);

          if (input.parentElement !== destination || label.parentElement !== destination) {
            destination.append(input, label);
          }

          if (unavailable) {
            unavailableCount += 1;
            selectedUnavailable = selectedUnavailable || input.checked;
          }
        });

        title.textContent = `${fieldset.dataset.unavailableLabel} (${unavailableCount})`;
        unavailablePanel.hidden = unavailableCount === 0;

        if (selectedUnavailable) setExpanded(true);
      };

      const observer = new MutationObserver(syncOptions);
      optionItems.forEach(({ input }) => {
        observer.observe(input, { attributes: true, attributeFilter: ['class'] });
      });

      fieldset.addEventListener('change', () => requestAnimationFrame(syncOptions));
      syncOptions();
    };

    const initializeAll = (root = document) => {
      if (root.matches && root.matches(pickerSelector)) initializePicker(root);
      root.querySelectorAll(pickerSelector).forEach(initializePicker);
    };

    window.DomovStromovVariantPicker = { initializeAll };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('.ds-variant-picker__toggle');
      if (!toggle) return;

      const unavailablePanel = toggle.closest('.ds-variant-picker__unavailable');
      const fieldset = toggle.closest(pickerSelector);
      const actionText = toggle.querySelector('.ds-variant-picker__toggle-action > span:first-child');
      if (!unavailablePanel || !fieldset || !actionText) return;

      setPanelExpanded(
        unavailablePanel,
        toggle,
        actionText,
        fieldset,
        toggle.getAttribute('aria-expanded') !== 'true'
      );
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
